// Catalogues other than English do not carry these messages, and they hold the count, so callers keep a fallback.
export const SELECTED_EMPLOYEES_DEFAULT_MESSAGE =
  '{count, plural, one {# Employee Selected} other {# Employees Selected}}'

export const ACTIVATION_DURATION_DEFAULT_MESSAGE = '{count, plural, one {# hour} other {# hours}}'
